import DOMPurify from 'dompurify';
import { marked } from 'marked';

export function mdToHtml(md)
{
    return DOMPurify.sanitize(marked.parse(md));
}